var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToggleBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #efefef;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #5b5b5b;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-toggle-btn",
    transform: "translate(-532 -1365)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3264",
    "data-name": "Ret\\xE2ngulo 3264",
    className: "cls-1",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(532 1365)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6529",
    "data-name": "Grupo 6529",
    transform: "translate(13.95 9.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-down",
    className: "cls-2",
    d: "M3.438,1.357a1,1,0,0,1,1.7,0L7.615,5.327a1,1,0,0,1-.848,1.53H1.8a1,1,0,0,1-.848-1.53Z",
    transform: "translate(532.403 1378.787) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-down-2",
    "data-name": "arrow-down",
    className: "cls-2",
    d: "M3.412,1.573a1,1,0,0,1,1.748,0L7.746,6.229a1,1,0,0,1-.874,1.486H1.7A1,1,0,0,1,.825,6.229Z",
    transform: "translate(533.697 1362.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_118",
    "data-name": "Linha 118",
    className: "cls-2",
    d: "M0,14.106a1.5,1.5,0,0,1-1.5-1.5V0A1.5,1.5,0,0,1,0-1.5,1.5,1.5,0,0,1,1.5,0V12.606A1.5,1.5,0,0,1,0,14.106Z",
    transform: "translate(537.983 1366.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_119",
    "data-name": "Linha 119",
    className: "cls-2",
    d: "M0,14.654a1.5,1.5,0,0,1-1.5-1.5V0A1.5,1.5,0,0,1,0-1.5,1.5,1.5,0,0,1,1.5,0V13.154A1.5,1.5,0,0,1,0,14.654Z",
    transform: "translate(528.118 1362.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleBtn);
export default __webpack_public_path__ + "static/media/icon-toggle-btn.0bc98c835d24631e96bde877e83d29a6.svg";
export { ForwardRef as ReactComponent };